import React, { forwardRef } from 'react'
import ReactQuill from 'react-quill-new'
import 'react-quill/dist/quill.snow.css'

const RichTextEditor = forwardRef((props, ref) => {

	const modules = {
		toolbar: [
		  [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
		  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
		  ['bold', 'italic', 'underline', 'strike'],  // Negrita, cursiva, subrayado, tachado
		  [{ 'color': [] }, { 'background': [] }],    // Color de texto y fondo
		  [{ 'align': [] }],                          // Alineación de texto
		  ['blockquote', 'code-block'],               // Cita y bloque de código
		  ['link', 'image', 'video'],                 // Enlace, imagen, video
		  [{ 'indent': '-1' }, { 'indent': '+1' }],   // Sangría
		  [{ 'direction': 'rtl' }],                   // Dirección de texto (de derecha a izquierda)
		  ['clean']                                   // Limpiar formato
		],
	  };
	  
	  const formats = [
		'header', 'font', 'list', 'bold', 'italic', 'underline', 'strike',
		'color', 'background', 'align', 'blockquote', 'code-block',
		'link', 'image', 'video', 'indent', 'direction'
	  ];
	return (
		<div className="rich-text-editor">
			<ReactQuill
			 ref={ref} 
			 modules={modules} 
			 formats={formats} 
			 {...props}
			/>
		</div>
	)
})

export default RichTextEditor
